export default __webpack_public_path__ + "static/media/BeVietnam-Bold.7b3a7ba6.ttf";